/* import __COLOCATED_TEMPLATE__ from './measure-and-improve-team-performance.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();